





















import { useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted
} from '@vue/composition-api';
import {
  groupsProvider,
  Group
} from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { useStore } from 'vuex-composition-helpers';

import { setErrorFromAxiosError } from '@/utils/helpers';

import { IRootState } from '@/store';
import { ISystemError } from '@/models/error/error.types';

import { VAutocomplete } from 'vuetify/lib/components';

export default defineComponent({
  name: 'GroupAutoCompletePicker',

  props: {
    value: [Array, Number, Object] as PropType<
      Group | number | (Group | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    clearable: {
      type: Boolean,
      default: true
    }
  },

  setup(props, { attrs }) {
    const groupVModel = useVModel(props);

    const store = useStore<IRootState>();

    const groupsStoreProvider = computed<any>(() => groupsProvider(store));

    const groups = computed(
      () => groupsStoreProvider.value.getPermissionGroups
    );

    const loading = ref(false);

    const isLoading = computed<boolean>(() =>
      Boolean(loading.value || (attrs.loading as boolean))
    );

    const error = ref<ISystemError | null>(null);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    onMounted(() => {
      loading.value = true;

      (groupsStoreProvider.value.fetchPermissionGroups() as Promise<any>)
        .catch(err => {
          error.value = setErrorFromAxiosError(err);
        })
        .finally(() => {
          loading.value = false;
        });
    });

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      groupVModel,
      groups,
      isLoading,
      errorMessageList
    };
  }
});
